import * as Yup from 'yup';

import { ERRORS_TEXTS } from '../../../../../../const/validation';

export const schema = Yup.object({
  coefficient: Yup.number()
    .positive(ERRORS_TEXTS.positive)
    .typeError(ERRORS_TEXTS.number)
    .required(ERRORS_TEXTS.required),
});

export type FormFields = {
  coefficient: number;
};
